import { ApiKeyInterceptor } from './services/api-key-interceptor';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BackendService } from './services/backend.service';
import { UiStateService } from './services/ui-state-service';
import { NgxSpinnerModule } from "ngx-spinner";

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
    ],
    exports: [
        CommonModule,
        HttpClientModule,
    ],
    providers: [
      BackendService,
      UiStateService,
      {
        provide: HTTP_INTERCEPTORS,
        useClass: ApiKeyInterceptor,
        multi: true
      }
    ]
})
export class CoreModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: CoreModule
        };
    }
}
